/* eslint-disable @typescript-eslint/unbound-method */

import { ServiceApi } from "@/apis/clients";
import { wrap } from "@/apis/wrap";

const serviceApi = {
  indexService: wrap(ServiceApi, ServiceApi.prototype.indexService),
  indexServiceName: wrap(ServiceApi, ServiceApi.prototype.indexServiceName),
  deleteService: wrap(ServiceApi, ServiceApi.prototype.deleteService),
  duplicateService: wrap(ServiceApi, ServiceApi.prototype.duplicateService),
  indexServiceHoldDate: wrap(
    ServiceApi,
    ServiceApi.prototype.indexServiceHoldDate,
  ),
  csvOrders: wrap(ServiceApi, ServiceApi.prototype.csvServiceOrders),
  showService: wrap(ServiceApi, ServiceApi.prototype.showService),
  showServiceAggregate: wrap(
    ServiceApi,
    ServiceApi.prototype.showServiceAggregate,
  ),
  showServiceAccess: wrap(ServiceApi, ServiceApi.prototype.showServiceAccess),
  indexServicePage: wrap(ServiceApi, ServiceApi.prototype.indexServicePage),
  indexServiceOrder: wrap(ServiceApi, ServiceApi.prototype.indexServiceOrder),
  // ※次フェーズ対応予定
  // indexServiceQuestionnaire: wrap(
  //   ServiceApi,
  //   ServiceApi.prototype.indexServiceQuestionnaire,
  // ),
  showServiceOrderSummary: wrap(
    ServiceApi,
    ServiceApi.prototype.getServiceOrderSummary,
  ),
  indexServiceQuestionnaire: wrap(
    ServiceApi,
    ServiceApi.prototype.indexServiceQuestionnaire,
  ),
  indexServiceDraft: wrap(ServiceApi, ServiceApi.prototype.indexServiceDraft),
  isDeletable: wrap(
    ServiceApi,
    ServiceApi.prototype.getServiceDeleteAvailability,
  ),

  postEventSeminar: wrap(ServiceApi, ServiceApi.prototype.postEventSeminar),
  postContentWebinar: wrap(ServiceApi, ServiceApi.prototype.postContentWebinar),
  postCalendar: wrap(ServiceApi, ServiceApi.prototype.postCalendar),
  postFormService: wrap(ServiceApi, ServiceApi.prototype.postFormService),
  postSurvey: wrap(ServiceApi, ServiceApi.prototype.postSurvey),
  postDocumentRequest: wrap(
    ServiceApi,
    ServiceApi.prototype.postDocumentRequest,
  ),
  postInquiry: wrap(ServiceApi, ServiceApi.prototype.postInquiry),
  postEmailNewsletter: wrap(
    ServiceApi,
    ServiceApi.prototype.postEmailNewsletter,
  ),
  postSubscription: wrap(ServiceApi, ServiceApi.prototype.postSubscription),
  putEventSeminar: wrap(ServiceApi, ServiceApi.prototype.putEventSeminar),
  putContentWebinar: wrap(ServiceApi, ServiceApi.prototype.putContentWebinar),
  putCalendar: wrap(ServiceApi, ServiceApi.prototype.putCalendar),
  putFormService: wrap(ServiceApi, ServiceApi.prototype.putFormService),
  putSurvey: wrap(ServiceApi, ServiceApi.prototype.putSurvey),
  putDocumentRequest: wrap(ServiceApi, ServiceApi.prototype.putDocumentRequest),
  putInquiry: wrap(ServiceApi, ServiceApi.prototype.putInquiry),
  putEmailNewsletter: wrap(ServiceApi, ServiceApi.prototype.putEmailNewsletter),
  putSubscription: wrap(ServiceApi, ServiceApi.prototype.putSubscription),

  getServicesByType: wrap(ServiceApi, ServiceApi.prototype.getServicesByType),
  getServiceEdit: wrap(ServiceApi, ServiceApi.prototype.getServiceEdit),
  showServiceForm: wrap(ServiceApi, ServiceApi.prototype.showServiceForm),
  putServicePagesChangeStatusPrivate: wrap(
    ServiceApi,
    ServiceApi.prototype.putServicePagesChangeStatusPrivate,
  ),
  getGaTagSettingService: wrap(
    ServiceApi,
    ServiceApi.prototype.getGaTagSettingService,
  ),
  getGtmTagSettingService: wrap(
    ServiceApi,
    ServiceApi.prototype.getGtmTagSettingService,
  ),
  updateGaTagSettingService: wrap(
    ServiceApi,
    ServiceApi.prototype.updateGaTagSettingService,
  ),
  updateGtmTagSettingService: wrap(
    ServiceApi,
    ServiceApi.prototype.updateGtmTagSettingService,
  ),
  // calendar サービス
  showServiceOrderCalendarSummary: wrap(
    ServiceApi,
    ServiceApi.prototype.getServiceOrderCalendarSummary,
  ),
  indexServiceOrderCalendar: wrap(
    ServiceApi,
    ServiceApi.prototype.indexServiceCalendarOrder,
  ),
  indexServiceCalendarPage: wrap(
    ServiceApi,
    ServiceApi.prototype.indexServiceCalendarPage,
  ),
  analystService: wrap(ServiceApi, ServiceApi.prototype.analystService),
  getServiceComponents: wrap(
    ServiceApi,
    ServiceApi.prototype.getServiceComponents,
  ),
  getServiceComponentsByIds: wrap(
    ServiceApi,
    ServiceApi.prototype.getServiceComponentsByIds,
  ),
  postGeneralPurpose: wrap(ServiceApi, ServiceApi.prototype.postGeneralPurpose),
  putGeneralPurpose: wrap(ServiceApi, ServiceApi.prototype.putGeneralPurpose),
  getCheckCustomUrl: wrap(ServiceApi, ServiceApi.prototype.indexCheckCustomUrl),
  getServiceMenus: wrap(ServiceApi, ServiceApi.prototype.getServiceMenus),
  getSubscriptionMenus: wrap(
    ServiceApi,
    ServiceApi.prototype.getSubscriptionMenus,
  ),
  postSubscriptionMenuLimit: wrap(
    ServiceApi,
    ServiceApi.prototype.postSubscriptionMenuLimit,
  ),
  indexServiceTicket: wrap(ServiceApi, ServiceApi.prototype.indexServiceTicket),
  getTicketDetail: wrap(ServiceApi, ServiceApi.prototype.getTicketDetail),
  updateTicket: wrap(ServiceApi, ServiceApi.prototype.updateTicket),
};

export default serviceApi;
